import {
  BaSeButton,
  BaSeDialogContext,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import { useUtilsService } from '../../components/shared/utils/utils';
import { useRelatorio } from '../../services/relatorio/RelatorioService';
import {
  WrapperActions,
  WrapperContentFilters,
  WrapperContentInput,
  WrapperFilters,
} from './new-relatorios-styled';

export const FiltrosPredefinidos = ({
  closeModal,
  filtrosLabel,
  params,
  setIsSucces,
  listaFiltros,
}) => {
  const [nome, setNome] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [isValidInput, setIsValidInput] = React.useState(true);
  const [messageNotification, setMessageNotification] = React.useState('');

  const { showNotification } = React.useContext(BaSeDialogContext);
  const { salvarFiltroPredefinido } = useRelatorio();
  const { isNotEmpty } = useUtilsService();
  const { cinzaSebrae45 } = BaSeTheme.colors.institucionais;
  const nomeRef = React.useRef(null);

  const labels = React.useMemo(
    () => ({
      tipoRelatorio: 'Tipo de relatório',
      periodo: 'Período',
      dataInicio: 'Data início',
      dataFim: 'Data fim',
      contatos: 'Contatos',
      conta: 'Contas',
      situacao: 'Situação',
      tipoLancamento: 'Tipo de Lançamento',
      categoria: 'Categorias',
      subcategoria: 'Subcatecorias',
    }),
    [],
  );

  const formatList = React.useCallback((values) => {
    if (values.length > 5) {
      return values.slice(0, 5).join(', ') + ` +${values.length - 5}`;
    }
    return values.join(', ');
  }, []);

  const formattedDate = React.useCallback((date, isDefaultFormat = false) => {
    if (!date) return;
    if (isDefaultFormat) {
      const [year, month, day] = date.split('-');
      return /-/.test(date) ? `${day}/${month}/${year}` : date;
    }
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }, []);

  const handleSalvar = React.useCallback(async () => {
    if (!isNotEmpty(nome)) {
      setIsValidInput(false);
      setMessageNotification('O nome é de preenchimento obrigatório!');
      nomeRef.current.focus();
      return;
    }
    const existeNome = listaFiltros.some((item) => item.nome === nome);
    if (existeNome) {
      setIsValidInput(false);
      nomeRef.current.focus();
      setMessageNotification(
        'Já existe um filtro predefinido com esse nome. Favor escolha um nome diferente!',
      );
      return;
    }

    setIsLoading(true);
    params.nome = nome;
    params.filtro.dataInicio = formattedDate(params.filtro.dataInicio);
    params.filtro.dataFim = formattedDate(params.filtro.dataFim);
    params.filtro.periodo = params.filtro.periodo.id;

    setIsLoading(false);
    await salvarFiltroPredefinido(params)
      .then(() => {
        setIsSucces(true);
        closeModal();
        showNotification({
          message: 'Filtro predefinido salvo com sucesso!',
          color: 'confirmation',
        });
      })
      .catch((error) => {
        closeModal();
        showNotification({
          message: 'Não foi possível salvar filtro predefinido!',
          color: 'destructive',
          supportMessage: error?.message ?? '',
        });
      })
      .finally(() => setIsLoading(false));
  }, [
    listaFiltros,
    isNotEmpty,
    nome,
    params,
    formattedDate,
    salvarFiltroPredefinido,
    setIsSucces,
    closeModal,
    showNotification,
  ]);

  return (
    <div>
      <BaSeSmall1 color={cinzaSebrae45}>
        Revise os filtros selecionados e dê um nome para salvar seu filtro
        personalizado.
      </BaSeSmall1>
      <WrapperFilters>
        {Object.entries(filtrosLabel).map(([key, value], i) => {
          const valueList = Array.isArray(value)
            ? value?.map((item) => item?.label ?? '')
            : [value].map((item) => item?.label ?? item);

          return valueList.length ? (
            <WrapperContentFilters key={i}>
              <BaSeParagraph isBold color={cinzaSebrae45}>{`${
                labels?.[key] ?? ''
              }: `}</BaSeParagraph>
              <BaSeParagraph color={cinzaSebrae45}>
                {formatList(valueList)}
              </BaSeParagraph>
            </WrapperContentFilters>
          ) : (
            ''
          );
        })}
      </WrapperFilters>
      <WrapperContentInput>
        <BaSeInput
          ref={nomeRef}
          value={nome}
          onChange={(e) => {
            if (isNotEmpty(e)) setIsValidInput(true);
            setNome(e);
          }}
          label="Nome do filtro predefinido"
          placeholder="Digite o nome do filtro"
          color={isValidInput ? 'default' : 'destructive'}
        />
        {!isValidInput && (
          <BaSeParagraph color="destructive">
            {messageNotification}
          </BaSeParagraph>
        )}
      </WrapperContentInput>
      <WrapperActions>
        <BaSeButton
          buttonType="button"
          color="default"
          isLoading={isLoading}
          onClick={handleSalvar}
          size="medium"
          type="primary"
          value="Salvar"
        />
        <BaSeButton
          buttonType="button"
          color="default"
          onClick={closeModal}
          size="medium"
          type="secondary"
          value="Cancelar"
        />
      </WrapperActions>
    </div>
  );
};
